import { publisher, sameAs } from './utils';

export const getVideoWebPageSchema = (pageData: Record<string, string>) => {
  const webPageSchema = {
    '@context': 'http://schema.org',
    '@type': 'WebPage',
    headline: pageData.seoTitle,
    description: pageData.seoDescription,
    url: pageData.canonical,
    datePublished: pageData.publishedAt,
    articleSection: 'video',
    creator: [],
    keywords: pageData.keywords,
    mainEntityOfPage: pageData.mainEntityId ? {
      '@type': 'WebPage',
      '@id': pageData.mainEntityId,
    } : undefined,
    publisher,
    sameAs,    
  };

  return webPageSchema;
};

export const getVideoPageSchema = (pageData: Record<string, string>) => {
  const videoPageSchema = {
    '@context': 'http://schema.org',
    '@type': 'VideoObject',
    name: pageData.seoTitle,
    description: pageData.seoDescription,
    thumbnailUrl: pageData.ogImageUrl,
    uploadDate: pageData?.uploadDate ? new Date(Number(pageData?.uploadDate) * 1000).toISOString() : '',
    contentUrl: pageData?.contentUrl,
    mentions: pageData?.mentions ? [
      {
        '@type': 'Thing',
        mentions: pageData?.mentions,
      },
    ] : undefined,
    duration: pageData?.duration ? secondsToISO8601(Number(pageData.duration)) : undefined,
    embedUrl: pageData?.embedUrl || undefined,
    genre: pageData.genre,
    headline: pageData.seoTitle,
    keywords: pageData.keywords,
    caption: pageData.seoTitle,
    ...(pageData.transcript ? { transcript: pageData.transcript } : {}),
    thumbnail: {
      '@type': 'ImageObject',
      url: pageData.ogImageUrl,
      height: 406,
      width: 720,
    },
    publisher
  };

  return videoPageSchema;
};


/**
 * Converts a duration in seconds to ISO 8601 duration format (e.g., PT1H30M45S)
 * @param seconds - Duration in seconds
 * @returns ISO 8601 duration string
 */
function secondsToISO8601(seconds: number): string {
  if (seconds < 0) {
    return "";
  }

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);

  let duration = 'PT';

  if (hours > 0) {
    duration += `${hours}H`;
  }

  if (minutes > 0) {
    duration += `${minutes}M`;
  }

  if (secs > 0 || duration === 'PT') {
    duration += `${secs}S`;
  }

  return duration;
}
